import { useTranslation } from "react-i18next";

import { asRiskLevel, type RiskLevel } from "../model/types";

/**
 * Цветная точка уровня риска (ТЗ §2): зелёная, жёлтая, оранжевая.
 *
 * Точка, а не эмодзи. Эмодзи из ТЗ (🟢🟡🟠) рисуется шрифтом системы: на
 * Android он плоский и ядовитый, на iOS объёмный, и в dark premium оба
 * выглядят инородно. Токен даёт тот же смысл и ту же палитру, что и остальной
 * интерфейс.
 *
 * Уровней три, а `--color-status-*` покрывает только прибыль и убыток —
 * средний берётся из `warning`, он же жёлтый в макете.
 */
const TONE: Record<RiskLevel, string> = {
  low: "bg-status-profit",
  medium: "bg-status-warning",
  high: "bg-chart-deposit",
};

export function RiskDot({ risk }: { risk: string }) {
  const { t } = useTranslation();
  const level = asRiskLevel(risk);
  return (
    <span
      className={`size-[7px] shrink-0 rounded-full ${TONE[level]}`}
      role="img"
      aria-label={t(`robots.risk.${level}`)}
    />
  );
}
